export default {
   tips: "Please browse through the series of product brochures for KELK to learn more about KELK's product specifications and services.",
   title1:'Upload time'
}


// WEBPACK FOOTER //
// ./src/config/lang/en/information.js